// SecondaryMenu.js
import React, { useState } from 'react';
import styled from 'styled-components';
import Document from '../Images/document.svg'
import Macros from '../Images/macros.svg';  // Changed from Spreadsheet to Macros
import DBSearch from '../Images/dbsearch.svg';  // Changed from Whiteboard to DBSearch
import Calculator from '../Images/calculator.svg';
import Food from '../Images/food.svg';  // Changed from Rate to Food
import ScientificCalculator from '../Components/ScientificCalculator';
import FoodCaloriesCalculator from '../Components/FoodCaloriesCalculator';
import Notes from '../Components/Notes';
import MacrosComponent from '../Components/Macros'; // Import the new structured Macros component
import DBSearchComponent from '../Components/DBSearch'; // Import the new DBSearch component

const Tooltip = styled.div`
  position: absolute;
  right: 100%;
  margin-right: 10px;
  padding: 5px 10px;
  background: linear-gradient(135deg, #1a1f2e 0%, #0f1419 100%);
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 6px;
  font-size: 12px;
  visibility: hidden;
  white-space: nowrap;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

const MenuItem = styled.div`
  padding: 10px;
  color: ${props => props.$disabled ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.9)'};
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  position: relative;

  &:hover {
    background-color: ${props => props.$disabled ? 'transparent' : 'rgba(255, 255, 255, 0.1)'};
    
    ${Tooltip} {
      visibility: visible;
    }
  }
`;

const MenuContainer = styled.div`
  width: 4%;
  background: linear-gradient(180deg, #0f1419 0%, #1a1f2e 100%);
  border-left: 1px solid rgba(100, 150, 200, 0.15);
  float: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 18px;
`;

const WindowContainer = styled.div`
  width: 280px;
  background: linear-gradient(180deg, #0f1419 0%, #1a1f2e 100%);
  float: left;
  display: ${props => props.$isOpen ? 'block' : 'none'};
  border-right: 1px solid rgba(100, 150, 200, 0.15);
  overflow-x: hidden;
`;

const MenuIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;

  img {
    filter: brightness(0) invert(1);
    opacity: ${props => props.$disabled ? '0.3' : '0.6'};
    transition: all 0.2s ease-in-out;
  }

  &:hover img {
    opacity: ${props => props.$disabled ? '0.3' : '1'};
  }
`;

const SecondaryMenu = ({ isWorkspace = false }) => {
  const [activeMenu, setActiveMenu] = useState(null);

  const toggleMenu = (menu, disabled) => {
    if (disabled) return;
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  return (
    <>
      <MenuContainer $isWorkspace={isWorkspace}>
        {/* Notes menu item - hidden
        <MenuItem onClick={() => toggleMenu('document')}>
          <MenuIcon>
            <img src={Document} alt="Notes" style={{ 
              width: "24px", 
              height: "24px",
              position: "relative",
              left: "0",
            }} />
          </MenuIcon>
          <Tooltip>Notes</Tooltip>
        </MenuItem>
        */}
        
        {/* Calculator menu item - hidden
        <MenuItem onClick={() => toggleMenu('calculator')}>
          <MenuIcon>
            <img src={Calculator} alt="Calculator" style={{ 
              width: "24px", 
              height: "24px",
              position: "relative",
              left: "0",
            }} />
          </MenuIcon>
          <Tooltip>Calculator</Tooltip>
        </MenuItem>
        */}

        {/* Macros menu item - hidden
        <MenuItem onClick={() => toggleMenu('macros')}>
          <MenuIcon>
            <img src={Macros} alt="Macros" style={{ 
              width: "24px", 
              height: "24px",
              position: "relative",
              left: "0",
            }} />
          </MenuIcon>
          <Tooltip>Macros</Tooltip>
        </MenuItem>
        */}

        {/* DB Search button - temporarily hidden
        <MenuItem $disabled={true} onClick={() => toggleMenu('dbsearch', true)}>
          <MenuIcon $disabled={true}>
            <img src={DBSearch} alt="DB Search" style={{ 
              width: "24px", 
              height: "24px",
              position: "relative",
              left: "0",
            }} />
          </MenuIcon>
          <Tooltip>DB Search (Disabled)</Tooltip>
        </MenuItem>
        */}

        {/* Food menu item - hidden
        <MenuItem onClick={() => toggleMenu('food')}>
          <MenuIcon>
            <img src={Food} alt="Food" style={{ 
              width: "24px", 
              height: "24px",
              position: "relative",
              left: "0",
            }} />
          </MenuIcon>
          <Tooltip>Food Calculator</Tooltip>
        </MenuItem>
        */}
      </MenuContainer>
      <WindowContainer $isOpen={activeMenu !== null} $isWorkspace={isWorkspace}>
        {activeMenu === 'document' && (
          <Notes />
        )}
        {activeMenu === 'calculator' && (
          <ScientificCalculator />
        )}
        {activeMenu === 'food' && (
          <FoodCaloriesCalculator />
        )}
        {activeMenu === 'macros' && (
          <MacrosComponent />
        )}
        {/* DBSearch component - temporarily hidden
        {activeMenu === 'dbsearch' && (
          <DBSearchComponent />
        )}
        */}
        {/* Add other components for different menu items if needed */}
      </WindowContainer>
    </>
  );
};

export default SecondaryMenu;
